/**
 * GA4 helpers — loads only when REACT_APP_GA4_MEASUREMENT_ID is set and analytics consent is true.
 */

const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || '';

let gtagLoaded = false;

function loadGtag() {
  if (gtagLoaded || typeof window === 'undefined' || !MEASUREMENT_ID) return;
  try {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
    gtagLoaded = true;
  } catch (_) {
    // Never allow third-party analytics bootstrapping to break app startup.
  }
}

/**
 * @param {boolean} analyticsAllowed
 */
export function initAnalytics(analyticsAllowed) {
  if (!analyticsAllowed || !MEASUREMENT_ID) return;
  loadGtag();
}

/**
 * @param {string} eventName
 * @param {Record<string, string | number | boolean>} [params]
 */
export function trackEvent(eventName, params = {}) {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}

/**
 * @param {string} path
 */
export function trackPageView(path) {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
  });
}

export function getMeasurementId() {
  return MEASUREMENT_ID;
}
